import { render } from "./LoadingAnimationScreen.vue?vue&type=template&id=9814e970&scoped=true&ts=true"
import script from "./LoadingAnimationScreen.vue?vue&type=script&lang=ts"
export * from "./LoadingAnimationScreen.vue?vue&type=script&lang=ts"

import "./LoadingAnimationScreen.vue?vue&type=style&index=0&id=9814e970&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9814e970"]])

export default __exports__